import React from 'react';
import Footer from '../Footer/Footer';
import Projects from '../Home/Projects/Projects';
import Navbar from '../Navbar/Navbar';

const Project = () => {
    return (
        <div>
            <Navbar/>
            <Projects/>
            <Footer/>
        </div>
    );
};

export default Project;